export default "__VITE_ASSET__24a4850b__"